import { GetBondsCallsParams } from '@goldwasserexchange/actor/rest-services';
import { createContext } from 'react';

export const bondCallParamsContext = createContext<Partial<GetBondsCallsParams>>({});
